import React, { useRef, useState ,useEffect} from 'react';
import PropTypes from 'prop-types';
import { Toast } from 'primereact/toast';
import './drop-file-input-array.css';

import { ImageConfig } from '../../config/ImageConfig';
import uploadImg from '../../assets/cloud-upload-regular-240.png';
import { Col, Row } from 'react-bootstrap';
import { table } from '@nextui-org/react';



const DropChange = (props) => {
    const wrapperRef = useRef(null);
    const toast = useRef(null);
    const [fileList, setFileList] = useState([]);
    useEffect(() => {
        
        props.CheckProofDocRequired(props.table, props.nameofFile, props.index);
    }, [props.values[props.table][props.index]]);


    const onDragEnter = () => wrapperRef.current.classList.add('dragover');
    const onDragLeave = () => wrapperRef.current.classList.remove('dragover');
    const onDrop = () => wrapperRef.current.classList.remove('dragover');

    const onFileDrop = (e) => {
        const newFile = e.target.files[0];
        const maxSizeInBytes = 5 * 1024 * 1024;
        const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf']; 
        if (!allowedTypes.includes(newFile.type)) {
            toast.current.clear();
            toast.current.show({
              severity: 'error',
              summary: 'Invalid file type',
              description:"Please upload an image (JPEG/PNG) or a PDF"
              ,
              life: 3000,
              sticky: false,
              content: (props) => (
                <div className="p-3" style={{ flex: '1' }}>
                    <div className="" style={{fontSize:"2.5dvh"}}>{props.message.summary}</div>                  
                    <div className=""  style={{fontSize:"2dvh"}}>{props.message.description}</div>                  
                </div>
              ),
            });
        
        }else     
        if (newFile.size > maxSizeInBytes) {
            toast.current.clear();
            toast.current.show({
              severity: 'error',
              summary: 'File size exceeds the limit',
              description:"Please upload a file less than 5 MB"
              ,
              life: 3000,
              sticky: false,
              content: (props) => (
                <div className="p-3" style={{ flex: '1' }}>
                    <div className="" style={{fontSize:"2.5dvh"}}>{props.message.summary}</div>                  
                    <div className=""  style={{fontSize:"2dvh"}}>{props.message.description}</div>                  
                </div>
              ),
            });                  
        }else

        if (newFile) {
            const currentData = props.values[props.table][props.index];
            
            const updatedList = [...fileList, newFile];
            setFileList(updatedList);

            const updatedData = {
                ...currentData,
               proof_doc: [
                ...(currentData.proof_doc || [""]),,  
                    {
                        file: newFile,
                        name: props.nameofFile,
                        id:props.id,
                    },
                ].filter(item => item.file),
            };
            
             
           
            const updatedDataArray = [...props.values[props.table]];
            updatedDataArray[props.index] = updatedData;        
          
   
            props.setFieldValue([props.table], updatedDataArray);

            
        }
        
    };
    const fileRemove = (file) => {
        const updatedList = [...fileList];
        updatedList.splice(fileList.indexOf(file), 1);
        setFileList(updatedList);
    
        const currentData = props.values[props.table][props.index];
      
        const updatedProofDoc = currentData.proof_doc.filter((item) => { 
        
          
            return (item.file) != (file);
        });

        const updatedData = {
            ...currentData,
            proof_doc: updatedProofDoc,
        };
    
        const updatedDataArray = [...props.values[props.table]];
        updatedDataArray[props.index] = updatedData;
    
        props.setFieldValue([props.table], updatedDataArray);
       
    };
    

    return (
        <div className='d-flex justify-content-center flex-column' style={{width:"100%"}}>
             <Toast ref={toast}  position="top-center"  />
        <label className='pt-3 ps-3' style={{height:"100%"}}>Proof Documents</label>
          {props.error&&   <small style={{color:"red"}} className=' ps-3'>{props.error}</small>}
          {props.nameofFile=='name' && <p style={{ fontSize: '13px' , marginLeft:'15px'}}>Name Proof	: Legal document indicating name change, such as a marriage certificate, divorce decree, or court order.</p>}
          {props.nameofFile=='birthday' && <p style={{ fontSize: '13px' , marginLeft:'15px'}}>Birthday Proof : Please provide birth certificate,passport, driver's license, or national ID card.</p>}
          {props.nameofFile=='nic' && <p style={{ fontSize: '13px' , marginLeft:'15px'}}>NIC Proof	: Valid government-issued photo identification required, such as a passport, driver's license, or national ID card.</p>}
          {props.nameofFile=='relationship' && <p style={{ fontSize: '13px' , marginLeft:'15px'}}>Relationship Proof : Please Provide birth certificate,marriage certificate, or court order.</p>}
        <Row className='my-4'>
            <Col xs={12}>
                <div
                    ref={wrapperRef}
                    className={`drop-file-input`}
                    onDragEnter={onDragEnter}
                    onDragLeave={onDragLeave}
                    onDrop={onDrop}
                    style={{borderColor:`${props.error?'red':'#11B1F0'}`}}
                >
                    <div className="drop-file-input__label d-flex justify-content-center flex-column">
                        <div className='d-flex justify-content-center'>
                            <img src={uploadImg} alt="" />
                        </div>
                        <p>Drag & Drop your files here</p>
                    </div>
                    <input type="file" name='nominee_proof_doc' onChange={onFileDrop}  required/>
                </div>
            </Col>

        </Row>
        <Row>
        <Col xs={12}>
    {fileList.length > 0 ? (
        <div className="drop-file-preview">
            <p className="drop-file-preview__title">
                Ready to upload
            </p>
            {fileList.map((item, index) => {
                const maxLength = 20; 
                const fileName = item.name;
                
              
                if (fileName.length > maxLength) {
                   
                    const extensionIndex = fileName.lastIndexOf('.');
                    const namePart = fileName.substring(0, extensionIndex);
                    const extension = fileName.substring(extensionIndex);
    
                    
                    const truncatedName = namePart.substring(0, maxLength - extension.length) + '...';
    
                    
                    const truncatedFileName = truncatedName + extension;
    
                    return (
                        <div key={index} className="drop-file-preview__item" style={{overflowX:"scroll"}}>
                            <img src={ImageConfig[item.type.split('/')[1]] || ImageConfig['default']} alt="" />
                            <div className="drop-file-preview__item__info">
                                <p>{truncatedFileName}</p>
                                <p>{item.size}B</p>
                            </div>
                            <span className="drop-file-preview__item__del" onClick={() => fileRemove(item)}>x</span>
                        </div>
                    );
                } else {
                    return (
                        <div key={index} className="drop-file-preview__item">
                            <img src={ImageConfig[item.type.split('/')[1]] || ImageConfig['default']} alt="" />
                            <div className="drop-file-preview__item__info">
                                <p>{fileName}</p>
                                <p>{item.size}B</p>
                            </div>
                            <span className="drop-file-preview__item__del" onClick={() => fileRemove(item)}>x</span>
                        </div>
                    );
                }
            })}
        </div>
    ) : null}
</Col>

        </Row>
    </div>
    );
};

DropChange.propTypes = {
    onFileChange: PropTypes.func,
};

export default DropChange;